import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToSpacesOverviewPage = () => {
  const { navigation } = useNavigation()

  return <Navigate replace to={navigation.spaceControl.overview.fullPath()} />
}

export default RedirectToSpacesOverviewPage
